import { Flex } from '@pinchenterprisesnpm/friday-ui'
import { EditIcon } from '@src/features/shift-post-v2/components/section-item/components/edit-icon/edit-icon'
import {
  SectionItemContainer,
  Title,
  DescriptionTitle,
  ShowFullDescriptionLink,
  OptionalTitle,
} from './section-item.styles'
import { ISectionItemProps } from './section-item.types'

export const SectionItem = ({
  title,
  descriptionTitle,
  hasEdit,
  onEdit,
  onShowFullDescription,
  children,
  style,
  isOptional,
  showFullDescriptionTitle,
  isEditDisabled,
  editDisabledTooltip,
}: ISectionItemProps) => {
  return (
    <SectionItemContainer style={style}>
      <Flex justify='space-between' align='center' wrap='nowrap'>
        <Flex align='center' wrap='nowrap'>
          <Title>{title}</Title>
          {isOptional && <OptionalTitle>{'Optional Step'}</OptionalTitle>}
          {descriptionTitle && <DescriptionTitle>{descriptionTitle}</DescriptionTitle>}
          {onShowFullDescription && (
            <ShowFullDescriptionLink onClick={onShowFullDescription}>
              {showFullDescriptionTitle || 'Show full description'}
            </ShowFullDescriptionLink>
          )}
        </Flex>
        {hasEdit && (
          <EditIcon
            onEdit={onEdit}
            isDisabled={isEditDisabled}
            disabledTooltipText={editDisabledTooltip}
          />
        )}
      </Flex>
      <Flex flex={1} flexDirection='column'>
        {children}
      </Flex>
    </SectionItemContainer>
  )
}
